import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/fleet", label: "Fleet" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || open ? "bg-[#050a12]/95 backdrop-blur-md border-b border-[#1a2838]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src="/images/logo-original.png" alt="1Motion Elite Transport" className="h-11 md:h-12 object-contain"/>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map(l => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`text-sm tracking-[0.18em] uppercase transition-colors ${
                loc.pathname === l.to ? "text-[#5DCFE5]" : "text-[#f0f6fb] hover:text-[#5DCFE5]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/book" data-testid="nav-book-now" className="btn-gold">Book Now</Link>
        </div>

        <button data-testid="mobile-menu-toggle" className="md:hidden text-[#f0f6fb]" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#050a12] border-t border-[#1a2838] px-6 py-6 space-y-4">
          {links.map(l => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="block text-[#f0f6fb] text-sm tracking-[0.18em] uppercase">
              {l.label}
            </Link>
          ))}
          <Link to="/book" onClick={() => setOpen(false)} data-testid="mobile-nav-book" className="btn-gold w-full justify-center">Book Now</Link>
        </div>
      )}
    </nav>
  );
}
